import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  /* 通用 */
  getMaterial: "/xxy/basic/material/getInfo",
  getProcedure: "/xxy/basic/techline/getProcedureByMaterialId",

  /* SPC analysis */
  getCate: "/xxy/inspect/inspecschema/getCateCode",
  getInspectRules: "/xxy/inspect/inspecschema/getInspectByCateCode",
  getProcedureList: "/xxy/inspect/inspecstatistic/getProcedureIdByCateCode",
  getMeasureData: "/xxy/inspect/spcAnaly/list",
  getNumberData: "/xxy/inspect/spcAnaly/list",
  getDevice: "/xxy/basic/deviceType/getInfo",
  getDeviceList: "/xxy/basic/device/getDevice",
  getAllConfig: "/xxy/device/config/listAll",

  /* -------------点检 && 保养--------------- */
  /* 库 */
  getMaintain: "/xxy/device/config/list", // 获取库
  singleRemove: "/xxy/device/config/remove",
  saveMaintain: "/xxy/device/config/save",
  getServeInfo: "/xxy/device/config/getInfo",

  /* 方案 */
  getScheme: "/xxy/device/configPath/list",
  batchDelSchema: "/xxy/device/configPath/batchRemove",
  delSchema: "/xxy/device/configPath/remove",
  saveSchema: "/xxy/device/configPath/save",
  schemaInfo: "/xxy/device/configPath/getInfo",

  /* 计划 */
  getPlan: "/xxy/device/configPlan/list",
  savePlan: "/xxy/device/configPlan/save",
  delPlan: "/xxy/device/configPlan/remove",
  batchDelPlan: "/xxy/device/configPlan/batchRemove",
  getPlanInfo: "/xxy/device/configPlan/getInfo",
  toDetail: "/xxy/device/configPlan/save",
  getDeviceByType: "/xxy/basic/device/listByTypeId",
  getSchemaByType: "/xxy/device/configPath/listByTypeId",

  /* 操作 */
  getDeviceByOp: "/xxy/basic/device/listByType",
  getOperateList: "/xxy/device/configTask/list",
  getListByConfigs: "/xxy/device/configPath/getDetailInfo", //弹窗内获取列表数据
  saveOperate: "/xxy/device/configTask/save",

  /* 查询 */
  getQuery: "/xxy/device/configTask/list",
  getResultInfo: "/xxy/device/configTask/getInfo"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}
/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
